import {useDispatch, useSelector} from "react-redux";
import {setWaste4ChangeBannerDetail, setWaste4ChangeErrorMessage} from "../../reducers/waste-4-change.reducer";
import React, {useEffect} from "react";
import {FIELD_LIST_INPUT_BANNER} from "../../utils/input-field-list-static-page";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const Banner = () => {
    const dispatch = useDispatch()
    const {bannerDetail, waste4ChangeErrorMessage} = useSelector(state => state.waste4ChangeReducer)
    const {fetching: getBanner} = useFetch(API.W4C_GET_BANNER)
    const {fetching: updateBanner, isLoading} = useFetch(API.W4C_UPDATE_BANNER)
    let fieldListInput = FIELD_LIST_INPUT_BANNER
    let showBanner = {
        label: 'Banner',
        key: 'show_banner',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setWaste4ChangeBannerDetail({[key]: value}))
    }

    useEffect(() => {
        getBanner().then(response => {
            dispatch(setWaste4ChangeBannerDetail(response.data))
        })

        return () => {
            dispatch(setWaste4ChangeErrorMessage({}))
        }
    }, [])

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateBanner(bannerDetail).then(response => {
            dispatch(setWaste4ChangeErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Banner Updated'))
            dispatch(setWaste4ChangeBannerDetail(response?.data))
        }).catch(err => {
            dispatch(setWaste4ChangeErrorMessage(convertErrorMessage(err)))
        })
    }

    return (
        <FormGeneralComponent
            data={bannerDetail}
            switchToggleField={showBanner}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={waste4ChangeErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default Banner